import { render, staticRenderFns } from "./CaseRoleCrud.vue?vue&type=template&id=5919ba3c&"
import script from "./CaseRoleCrud.vue?vue&type=script&lang=js&"
export * from "./CaseRoleCrud.vue?vue&type=script&lang=js&"
import style0 from "./CaseRoleCrud.vue?vue&type=style&index=0&id=5919ba3c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports